export default {
    me: null,
    connectionError: false,
    accounts: [],
    lineups: [], // List of lineups (team participation) with Reva status
    players: [], // List of players with Reva status
    priceLists: {}, // List of price templates indexed by tournament_id
    debtSummary: {}, // Summary of debts by type
    selectedLineupInvoices: [], // List of invoices for selected lineup
    selectedPlayerInvoices: [], // List of invoices for selected player
    selectedLineupFinancials: {
        balance: {
            available: 0,
            pending: 0
        },
        transactions: []
    },
    selectedPlayerFinancials: {
        balance: {
            available: 0,
            pending: 0
        },
        transactions: []
    },
    siloBalances: [], // General silo balances (Entities & Individuals)
    selectedLineupSiloBalances: [], // Silo balances for a specific lineup (Individual accounts)
    incomeSummary: {
        overview: {
            total_collected: 0,
            total_pending: 0,
            currency: "PYG"
        },
        itemized_by_type: {},
        by_relationship: {},
        by_entity: []
    }
};

